import { render, staticRenderFns } from "./VistaModeloProyectos.vue?vue&type=template&id=7238c91e&"
import script from "./VistaModeloProyectos.vue?vue&type=script&lang=js&"
export * from "./VistaModeloProyectos.vue?vue&type=script&lang=js&"
import style0 from "./VistaModeloProyectos.vue?vue&type=style&index=0&id=7238c91e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports